import{a as t}from"./chunk-RAAYCPUM.js";function l(...e){return t(u,e)}function u(e,a){let n={};for(let[o,r]of Object.entries(e)){let y=a(o,r,e);n[y]=r}return n}export{l as a};
